import { httpClient } from '@/services/http/httpClient'

type DeletePortfolioColumnParams = {
  portfolioColumnId: string
  portfolioId: string
  type: string
}

export async function deletePortfolioColumn({
  portfolioColumnId,
  portfolioId,
  type,
}: DeletePortfolioColumnParams) {
  await httpClient.delete(`/projects/portfolio-columns/${portfolioColumnId}`, {
    params: {
      type,
    },
    data: {
      portfolioId,
    },
  })
}
